<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 14 18"
  fill="none"
>
  <path
    d="M3.75 0.75C3.75 0.336 4.086 0 4.5 0H9C9.414 0 9.75 0.336 9.75 0.75C9.75 1.164 9.414 1.5 9 1.5H4.5C4.086 1.5 3.75 1.164 3.75 0.75ZM13.3193 15.3735L10.512 9.4815C9.73125 7.842 9 6.04575 9 4.22625V3H7.5V4.5C7.5675 6.53325 8.373 8.47875 9.1575 10.1265L11.9647 16.017C12.072 16.2435 11.9137 16.5 11.6827 16.5H10.56L7.27725 9.75H4.51575C5.17725 8.319 5.93025 6.46725 5.9955 4.5L6 3H4.5V4.22625C4.5 6.04575 3.76875 7.84125 2.988 9.48075L0.18075 15.3727C0.0569999 15.6337 0 15.9038 0 16.1663C0 17.1285 0.76725 18 1.81725 18H11.6827C12.7327 18 13.5 17.1285 13.5 16.1655C13.5 15.903 13.443 15.6337 13.3193 15.3735Z"
    [attr.fill]="color"
  />
</svg>
